// FlipCards.jsx
import React from "react";
import "./FlipCards.css";
import UK from '../asset/UK.jpeg';
import AUS from '../asset/AUS.png';
import ITALY from '../asset/ITALY.png';
import GERMANY from '../asset/GERMANY.png';
import FRANCE from '../asset/FRANCE.png';
import RUSSIA from '../asset/RUSSIA.png';
import SPAIN from '../asset/SPAIN.png';
import JAPAN from '../asset/JAPAN.png';
import CZECH from '../asset/Cz.png';


const cards = [
  {
    id: 1,
    front: <img src={UK} alt="Card 1" />,
    back: "United Kingdom offers a 2-year post-study work visa under the Graduate Route. Students can work part-time earning between £8 to £25 per hour. Known for its welcoming atmosphere, the UK provides excellent opportunities across all streams, including Law."
  },
  {
    id: 2,
    front: <img src={AUS} alt="Card 2" />,
    back: "Australia offers up to a 4-year post-study work visa depending on the program and region. Students can work part-time for up to 48 hours per fortnight, earning competitive hourly wages. With globally recognized universities, a safe environment, and strong support for international students, Australia is a top choice for higher education across all fields.",
  },
  {
    id: 3,
    front: <img src={ITALY} alt="Card 3" />,
    back: "Italy provides a 12-month post-study stay option for international graduates to seek employment. Students can work part-time while studying, earning around €8 to €15 per hour. Known for its rich cultural heritage, affordable education, and a wide range of English-taught master's programs, Italy is an attractive destination for students from all academic backgrounds.",
  },
  {
    id: 4,
    front: <img src={RUSSIA} alt="Card 4" />,
    back: "Russia allows international students to work part-time during their studies without needing a separate work permit. After graduation, students can apply for a temporary residence or work visa. With affordable tuition fees, strong academic programs in medicine, engineering, and science, and globally recognized degrees, Russia is an emerging hub for international education.",

  },
  {
    id: 5,
    front: <img src={JAPAN} alt="Card 5" />,
    back: "Japan permits international students to work up to 28 hours per week during their studies. After graduation, students can apply for a job-seeking visa valid for up to 1 year. With cutting-edge technology, high-quality education, and a strong job market, Japan offers great opportunities for students in fields like engineering, IT, business, and language studies.",
  },
  {
    id: 6,
    front: <img src={FRANCE} alt="Card 6" />,
    back: "France offers a 1-year post-study work visa for international graduates, extendable based on employment. Students can work part-time up to 964 hours per year (around 20 hours per week) while studying. Known for its world-class education system, affordable tuition, and diverse English-taught programs, France is a popular destination for students across all disciplines.",
  },
  {
    id: 7,
    front: <img src={GERMANY} alt="Card 7" />,
    back: "Germany offers an 18-month post-study job search visa to international graduates. While studying, students can work part-time up to 20 hours per week. With no or very low tuition fees at public universities, top-quality education, and strong career prospects in engineering, IT, and business, Germany remains one of the most sought-after study destinations in Europe.",
  },
  {
    id: 8,
    front: <img src={SPAIN} alt="Card 8" />,
    back: "Spain allows international graduates to apply for a 12-month post-study residence permit to seek employment or start a business. Students can work part-time up to 30 hours per week during their studies. With affordable living costs, vibrant culture, and a growing number of English-taught programs, Spain is an excellent choice for higher education across various fields.",
  },
  {
    id: 9,
    front: <img src={CZECH} alt="Card 9" />,
    back: "The Czech Republic offers international graduates the opportunity to stay in the country for up to 9 months after graduation through a post-study long-term residence permit to seek employment or start a business. During their studies, students are allowed to work part-time without needing a work permit, making it easier to gain practical experience. Known for its affordable tuition, low living costs, and safe environment, the Czech Republic is home to a wide range of English-taught programs and globally recognized universities",
  },
];

const FlipCards = () => {
  return (
    <>
      <div className="Free whi">
        <div className="Contain whi">
          <h1>Study in Abroad</h1>
        </div>
      </div>
    <div className="flip-container">
      {cards.map((card) => (
        <div className="card-wrapper" key={card.id}>
          <div className="card">
            <div className="front">{card.front}</div>
            <div className="back">{card.back}</div>
          </div>
        </div>
      ))}
    </div>
    </>
  );
};

export default FlipCards;
